export const MessageTypes = {
  Error: "error",
  Info: "info",
  Success: "success",
  Warning: "warning"
};

const messages = [
  {
    msg_code:"verification_under_progress",
    msg_type:MessageTypes.Info,
    msg_text:"Heads up! Depending on the size of your list, verification may take a few hours. We'll email you when it's ready to be downloaded."
  },
  {
    msg_code: "old_new_passwords_matched",
    msg_type: MessageTypes.Error,
    msg_text: "Old and new passwords cannot be the same"
  },
  {
    msg_code: "passwords_mismatched",
    msg_type: MessageTypes.Error,
    msg_text: "New and confirm passwords are not matched"
  },
  {
    msg_code: "user_already_verified",
    msg_type: MessageTypes.Error,
    msg_text: "Your account is already verified."
  },
  {
    msg_code: "reverify_again",
    msg_type: MessageTypes.Error,
    msg_text: "Something went wrong. Please try again"
  },
  {
    msg_code: "user_verify_link_expired",
    msg_type: MessageTypes.Error,
    msg_text:
      "The link you cliked is expired. Kindly request to resend activation link"
  },
  {
    msg_code: "session_expired",
    msg_type: MessageTypes.Error,
    msg_text: "Your session has been expired. please login to continue"
  },
  {
    msg_code: "token_not_found",
    msg_type: MessageTypes.Error,
    msg_text: "Your link has been expired. Please resend activation link to continue"
  },
];

export const getMessage = msgcode => {
  let msg;
  try {
    msg = messages.find(function(message) {
      return message.msg_code == msgcode;
    });

    if (msg == undefined) msg = { msg_code: "", msg_type: "", msg_text: "" };
  } catch (error) {
    msg = { msg_code: "", msg_type: "", msg_text: "" };
  } finally {
    return msg;
  }
};

export const getExceptionMessage = ex => {
  return {
    msg_code: "Exception",
    msg_type: MessageTypes.Error,
    msg_text: ex.message
  };
};

export const getCustomMessage = (msgCode, msgType, msgText) => {
  return { msg_code: msgCode, msg_type: msgType, msg_text: msgText };
};



// WEBPACK FOOTER //
// ./src/utility/Messages.js